import script from "./TextChangeDiff.vue?vue&type=script&setup=true&lang=js"
export * from "./TextChangeDiff.vue?vue&type=script&setup=true&lang=js"

import "./TextChangeDiff.vue?vue&type=style&index=0&id=eef105a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eef105a2"]])

export default __exports__